import {ProviderServiceModel} from "../../../provider/service/api/entity/providerService.model";
import {PartnerSummaryModel} from "../../../partner/common/api/model/partnerSummary.model";
import {WithSummaryModel} from "../../../common/entity/dto/plain/withSummary.model";
import {SubscriptionSummaryModel} from "./subscriptionSummary.model";
import {AccountSummary} from "../../../../shared/model/account/accountSummary.model";
import {PriceListSummaryModel} from "../../pricelist/api/entity/priceListSummary.model";
import {Moment} from "moment";
import {LovValueSummary} from "../../../common/lov/lov-value/api/model/lovValueSummary.model";

export class SubscriptionModel extends WithSummaryModel<SubscriptionSummaryModel> {
    providerService: ProviderServiceModel;
    default: boolean;
    partner: PartnerSummaryModel;
    account: AccountSummary;
    priceList: PriceListSummaryModel;
    active: boolean;
    metadata: string;
    startDate: Moment;
    endDate: Moment;
    billingType: LovValueSummary;
    billingFrequency: LovValueSummary;
    errors: string;

    get errorAsList(): string [] {
        return !this.errors ? [] : this.errors.split(',');
    }

    get errorLabelsAsList(): string[] {
        return this.errorAsList.map(value => {
            switch(value) {
                case SubscriptionErrors.SUBSCRIPTION_ERROR_MISSING_PARTNER:
                    return 'Client Mawi manquant';
                case SubscriptionErrors.SUBSCRIPTION_ERROR_MISSING_STRIPE_CLIENT:
                    return 'Client Stripe manquant';
                case SubscriptionErrors.SUBSCRIPTION_ERROR_MISSING_STRIPE_SUBSCRIPTION:
                    return 'Abonnement Stripe manquant';
                case SubscriptionErrors.SUBSCRIPTION_ERROR_MISSING_STRIPE_PAYMENT_METHOD:
                    return 'Moyen de paiment Stripe manquant';
                case SubscriptionErrors.SUBSCRIPTION_ERROR_STRIPE_PAYMENT_ERROR:
                    return 'Problème paiement Stripe';
                default:
                    return value;
            }
        })
    }
}

export enum SubscriptionErrors {
    SUBSCRIPTION_ERROR_MISSING_STRIPE_SUBSCRIPTION = 'SUBSCRIPTION_ERROR_MISSING_STRIPE_SUBSCRIPTION',
    SUBSCRIPTION_ERROR_MISSING_PARTNER = 'SUBSCRIPTION_ERROR_MISSING_PARTNER',
    SUBSCRIPTION_ERROR_MISSING_STRIPE_CLIENT = 'SUBSCRIPTION_ERROR_MISSING_STRIPE_CLIENT',
    SUBSCRIPTION_ERROR_MISSING_STRIPE_PAYMENT_METHOD = 'SUBSCRIPTION_ERROR_MISSING_STRIPE_PAYMENT_METHOD',
    SUBSCRIPTION_ERROR_STRIPE_PAYMENT_ERROR = 'SUBSCRIPTION_ERROR_STRIPE_PAYMENT_ERROR'
}
